<template>
  <div id="app" :class="$t('language.name')">
    <router-view/>
  </div>
</template>
<script>
import {getLanguage} from '@api/index'
  import { localLanguageVal } from '@/utils/autoScale'
export default {
  
  mounted () {
    if(!localStorage.getItem('sensfootLanguage') && (location.hash.indexOf("/en/")<0) && (location.hash.indexOf("/cn/")<0)){

      getLanguage({}).then(res=>{
            let localLanguage = localLanguageVal().replace("/","")
            console.log(localLanguage)
            if(localLanguage != res.msg){
            localStorage.setItem('sensfootLanguage',res.msg)
            location.reload()
              
            }
    }) 
    }
  },
}
</script>

<style lang="stylus">
  #logo
    display none;width 184px;height 44px;background-image url("~@/assets/images/public/logo1.svg");background-repeat no-repeat;background-position center center;background-size contain
  ::-webkit-scrollbar {width: 6px;height: 6px;background-color: #F5F5F5;}
  ::-webkit-scrollbar-thumb {background-color: #999;}
  ::-webkit-scrollbar-track {background-color: #F5F5F5;}
</style>
